import { render } from "./TransportationTicketCardComponent.vue?vue&type=template&id=29d003cb&scoped=true&ts=true"
import script from "./TransportationTicketCardComponent.vue?vue&type=script&lang=ts"
export * from "./TransportationTicketCardComponent.vue?vue&type=script&lang=ts"

import "./TransportationTicketCardComponent.vue?vue&type=style&index=0&id=29d003cb&scoped=true&lang=scss"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d003cb"]])

export default __exports__